import { render, staticRenderFns } from "./barrage.vue?vue&type=template&id=da731244&scoped=true"
import script from "./barrage.vue?vue&type=script&lang=js"
export * from "./barrage.vue?vue&type=script&lang=js"
import style0 from "./barrage.vue?vue&type=style&index=0&id=da731244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da731244",
  null
  
)

export default component.exports